import React from 'react'
import Typography from '@material-ui/core/Typography';

const Settings = () => (
  <Typography component="h1" variant="h4">Settings</Typography>
)

export default Settings;
